export const NURSERY_DISCOUNTS_DROPDOWN_LIST = 'NURSERY_DISCOUNTS_DROPDOWN_LIST'
export const NURSERY_DISCOUNTS_DROPDOWN_LIST_SUCCESS = 'NURSERY_DISCOUNTS_DROPDOWN_LIST_SUCCESS'
export const NURSERY_DISCOUNTS_DROPDOWN_LIST_FAILED = 'NURSERY_DISCOUNTS_DROPDOWN_LIST_FAILED'

export const GET_NURSERY_DISCOUNTS_DROPDOWN_ITEM = 'GET_NURSERY_DISCOUNTS_DROPDOWN_ITEM'
export const GET_NURSERY_DISCOUNTS_DROPDOWN_ITEM_SUCCESS = 'GET_NURSERY_DISCOUNTS_DROPDOWN_ITEM_SUCCESS'
export const GET_NURSERY_DISCOUNTS_DROPDOWN_ITEM_FAILED = 'GET_NURSERY_DISCOUNTS_DROPDOWN_ITEM_FAILED'

export const CLEAR_NURSERY_DISCOUNTS_DROPDOWN_LIST = 'CLEAR_NURSERY_DISCOUNTS_DROPDOWN_LIST'
